// removed by extract-text-webpack-plugin
module.exports = {"need-offer-by-category":"need-offer-by-category","need-offer-by-category-img-wrap":"need-offer-by-category-img-wrap","product-image":"product-image","description-black":"description-black","description-red":"description-red","description-link":"description-link"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/need-offer-by-category/style.scss
// module id = ./components/partials/need-offer-by-category/style.scss
// module chunks = 0